export default __webpack_public_path__ + "static/media/Emblem_of_Laos.svg_.cad466b2.png";